import React, { useEffect, useState } from 'react'
import { Button, Col, Divider, Drawer, Input, Row, Typography, Upload, message } from 'antd'
import { UploadOutlined } from '@ant-design/icons'
import PersonalizacionTicketPreview from './personalizacionTicketPreview'

const { Title } = Typography
const { TextArea } = Input

const ALLOWED_LOGO_TYPES = ['image/png', 'image/jpeg']
const MAX_LOGO_SIZE_BYTES = 500 * 1024 // 500KB

function PersonalizacionTicketCompanyDrawer(props) {
  const [ticketLogo, setTicketLogo] = useState('')
  const [ticketLegend, setTicketLegend] = useState('')
  const [ticketTitle, setTicketTitle] = useState('')
  const [showLogoExample, setShowLogoExample] = useState(false)

  useEffect(() => {
    if (props.visible && props.editData) {
      setTicketLogo(props.editData.ticket_logo || '')
      setTicketLegend(props.editData.ticket_legend || '')
      setTicketTitle(props.editData.ticket_title || '')
    }
  }, [props.visible, props.editData])

  const onSaveButton = () => {
    props.saveButton(props.editData.id, {
      ticket_logo: ticketLogo,
      ticket_legend: ticketLegend,
      ticket_title: ticketTitle,
    })
  }

  return (
    <Drawer placement="right" closable={false} onClose={props.closable} visible={props.visible} width={680}>
      <Title>{`Personalización del ticket — ${props.editData?.name || ''}`}</Title>
      <div style={{ color: 'rgba(0, 0, 0, 0.45)', marginBottom: 12 }}>Esto aplica a todas las tiendas de esta empresa.</div>
      <Divider className={'divider-custom-margins-users'} />
      <Row gutter={16} className={'section-space-field'}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <div className={'title-space-field'}>Logo del ticket</div>
          <div style={{ color: 'rgba(0, 0, 0, 0.45)', marginBottom: 8 }}>Se imprime arriba del ticket de venta y de la comanda de entrega, en todas las tiendas de la empresa. No afecta los datos fiscales que exige SAT.</div>
          <Upload
            accept="image/png,image/jpeg"
            showUploadList={false}
            beforeUpload={file => {
              if (!ALLOWED_LOGO_TYPES.includes(file.type)) {
                message.error('El logo debe ser una imagen PNG o JPG')
                return Upload.LIST_IGNORE
              }
              if (file.size > MAX_LOGO_SIZE_BYTES) {
                message.error('El logo no puede pesar más de 500KB')
                return Upload.LIST_IGNORE
              }

              const reader = new FileReader()
              reader.onload = () => setTicketLogo(reader.result)
              reader.readAsDataURL(file)
              return false
            }}
          >
            <Button icon={<UploadOutlined />}>{ticketLogo ? 'Cambiar logo' : 'Subir logo'}</Button>
          </Upload>
          <Button type="link" style={{ paddingLeft: 12 }} onClick={() => setShowLogoExample(!showLogoExample)}>
            {showLogoExample ? 'Ocultar ejemplo y medidas' : 'Ver ejemplo y medidas recomendadas'}
          </Button>
          {showLogoExample && (
            <div style={{ maxWidth: 360, marginTop: 8, padding: 12, background: '#fafafa', border: '1px solid #f0f0f0', borderRadius: 4 }}>
              <img src="ejemplo-logo-ticket.png" alt="Ejemplo de logo para ticket" style={{ width: '100%', marginBottom: 8 }} />
              <ul style={{ paddingLeft: 18, margin: 0 }}>
                <li>Tamaño recomendado: entre 300×120px y 600×200px (más ancho que alto)</li>
                <li>Blanco y negro, alto contraste — la impresora térmica solo imprime en negro, no capta colores ni degradados</li>
                <li>Fondo blanco o transparente, sin fotos ni detalles finos (se pierden al imprimir)</li>
                <li>Formato PNG o JPG, menos de 500KB</li>
              </ul>
            </div>
          )}
          {ticketLogo && (
            <div style={{ marginTop: 12 }}>
              <img src={ticketLogo} alt="Logo del ticket" style={{ maxWidth: '160px', maxHeight: '100px' }} />
              <div>
                <Button type="link" danger onClick={() => setTicketLogo('')}>Quitar logo</Button>
              </div>
            </div>
          )}
        </Col>
        <Col xs={24} sm={24} md={24} lg={24} className={'section-space-field'}>
          <div className={'title-space-field'}>Título del ticket</div>
          <div style={{ color: 'rgba(0, 0, 0, 0.45)', marginBottom: 8 }}>Se muestra arriba del detalle cuando la venta todavía no está certificada con FEL (ej. "TICKET DE VENTA"). Dejalo vacío para usar el título por defecto.</div>
          <Input
            value={ticketTitle}
            onChange={e => setTicketTitle(e.target.value)}
            placeholder="TICKET DE VENTA"
            maxLength={100}
          />
        </Col>
        <Col xs={24} sm={24} md={24} lg={24} className={'section-space-field'}>
          <div className={'title-space-field'}>Leyenda final</div>
          <div style={{ color: 'rgba(0, 0, 0, 0.45)', marginBottom: 8 }}>Mensaje propio de la empresa que se imprime al final, después de los datos fiscales (ej. "Gracias por su compra, esperamos que vuelva"). Opcional.</div>
          <TextArea
            value={ticketLegend}
            onChange={e => setTicketLegend(e.target.value)}
            placeholder="Gracias por su compra, esperamos que vuelva"
            maxLength={500}
            rows={2}
          />
        </Col>
      </Row>
      <Divider className={'divider-custom-margins-users'} />
      <div className={'title-space-field'}>Vista previa</div>
      <div style={{ color: 'rgba(0, 0, 0, 0.45)', marginBottom: 12 }}>Con datos de ejemplo, a 3 pulgadas — el ancho real depende de la configuración de cada tienda.</div>
      <PersonalizacionTicketPreview
        logo={ticketLogo}
        printWidth={'3'}
        legend={ticketLegend}
        subjectQuarterlyIsr={!!props.editData?.subject_quarterly_isr}
        ivaRetentionAgent={!!props.editData?.iva_retention_agent}
      />
      <Divider className={'divider-custom-margins-users'} />
      <Row gutter={16}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <div className="text-right">
            <Button type="link" className="cancel-button" onClick={() => props.cancelButton()}>
              Cancelar
            </Button>
            <Button htmlType="submit" className="title-tendero new-button" onClick={onSaveButton}>
              Guardar
            </Button>
          </div>
        </Col>
      </Row>
    </Drawer>
  )
}

export default PersonalizacionTicketCompanyDrawer
